import React from 'react';
import { ServerIcon } from 'tuui';
import { useAvailableItems } from 'hooks';
import { RadioCards } from 'modules/onboarding/OnboardingJourneyForm/components/radioCards/RadioCards';
import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { ENTITY, ENTITY_TO_PATH_MAP } from '../../config';
import { trackingSetupOptions } from '../../config/trackingMethodsConstants';
import styles from './trackingSetupMethodRadioGroup.module.scss';

const serverToServerOption = {
    id: ENTITY.S2S_SETUP,
    Icon: ServerIcon,
    title: (
        <FormattedMessage
            id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.S2S_SETUP}.label`}
            defaultMessage="Server to Server"
        />
    ),
    description: (
        <FormattedMessage
            id={`tracking.setup.modal.${ENTITY_TO_PATH_MAP.S2S_SETUP}.description`}
            defaultMessage="Send conversion data directly from your server to Realize. Best for offline events, MMPs, or other measurement platforms."
        />
    ),
    enabled: true,
    isRecommended: false,
};

export const TrackingSetupMethodRadioGroup = ({ type, setType }) => {
    const isShopifyEnabled = useConfigMatch({
        [FEATURE_FLAGS.SHOW_SHOPIFY_SETUP]: 'true',
    });

    const trackingSetupWithServerOptions = [
        ...trackingSetupOptions?.slice(0, 2),
        serverToServerOption,
        ...trackingSetupOptions?.slice(2),
    ];

    const options = useAvailableItems(trackingSetupWithServerOptions, { isShopifyEnabled });
    const convertedOptions = options ? [{ ...options[0], isRecommended: true }, ...options.slice(1)] : [];
    return (
        <RadioCards
            options={convertedOptions}
            id="tracking_setup_method_radio_group"
            name="tracking_setup_method_radio_group"
            selectedValue={type}
            onChange={setType}
            className={styles['group']}
        />
    );
};

export default TrackingSetupMethodRadioGroup;
